import { render, staticRenderFns } from "./section-settings.vue?vue&type=template&id=2b9d1c2a&"
import script from "./section-settings.vue?vue&type=script&lang=ts&"
export * from "./section-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports